class MapSK {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        document.querySelectorAll('[data-map]').forEach(el => {
            new MapItemSK(el, this)
        })
    }
}

class MapItemSK {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.run()
    }
    run() {
        const customMapType = new google.maps.StyledMapType([{
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
                "saturation": 36
            }, {
                "color": "#000000"
            }, {
                "lightness": 40
            }]
        }, {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#000000"
            }, {
                "lightness": 16
            }]
        }, {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 20
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 17
            }, {
                "weight": 1.2
            }]
        }, {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative.country",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "administrative.country",
            "elementType": "labels.text",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }, {
                "saturation": "-100"
            }, {
                "lightness": "30"
            }]
        }, {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative.land_parcel",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }, {
                "gamma": "0.00"
            }, {
                "lightness": "74"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 20
            }]
        }, {
            "featureType": "landscape.man_made",
            "elementType": "all",
            "stylers": [{
                "lightness": "3"
            }]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 21
            }]
        }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 17
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 29
            }, {
                "weight": 0.2
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 18
            }]
        }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 16
            }]
        }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 19
            }]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            }, {
                "lightness": 17
            }]
        }], {
            name: 'Roadmap'
        });
        const customMapTypeId = 'custom_style';

        const mapData = JSON.parse(this.element.dataset.map)
        const map = new google.maps.Map(this.element, {
            center: { lat: mapData[0].lat, lng: mapData[0].lng },
            zoom: 12,
            mapTypeControlOptions: {
                mapTypeIds: ['satellite', customMapTypeId]
            }
        })
        map.mapTypes.set(customMapTypeId, customMapType)
        map.setMapTypeId(customMapTypeId)

        const markers = []
        for (let j = 0; j < mapData.length; j++) {
            const marker = new google.maps.Marker({
                position: { lat: mapData[j].lat, lng: mapData[j].lng },
                map: map,
                title: mapData[j].title
            })
            markers.push(marker)
        }

        if (markers.length < 2) {
            return
        }

        const bounds = new google.maps.LatLngBounds()
        markers.forEach(marker => {
            bounds.extend(marker.getPosition())
        })
        map.fitBounds(bounds)


        const ne = bounds.getNorthEast()
        const sw = bounds.getSouthWest()
        const padding = 0.1
        const newNE = new google.maps.LatLng(ne.lat() + padding, ne.lng() + padding)
        const newSW = new google.maps.LatLng(sw.lat() - padding, sw.lng() - padding)
        const newBounds = new google.maps.LatLngBounds(newSW, newNE)
        map.fitBounds(newBounds)
    }
}

export default MapSK